module.exports = require("rn-fetch-blob");